"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Bundle_Request = exports.Bundle_RequestMethodKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_instant_1 = require("../Scalar/RTTI_instant");
var Bundle_RequestMethodKind;
(function (Bundle_RequestMethodKind) {
    Bundle_RequestMethodKind["_get"] = "GET";
    Bundle_RequestMethodKind["_head"] = "HEAD";
    Bundle_RequestMethodKind["_post"] = "POST";
    Bundle_RequestMethodKind["_put"] = "PUT";
    Bundle_RequestMethodKind["_delete"] = "DELETE";
    Bundle_RequestMethodKind["_patch"] = "PATCH";
})(Bundle_RequestMethodKind = exports.Bundle_RequestMethodKind || (exports.Bundle_RequestMethodKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Bundle_Request = t.recursion('IBundle_Request', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        method: (0, EnumType_1.createEnumType)(Bundle_RequestMethodKind, 'Bundle_RequestMethodKind'),
        _method: RTTI_Element_1.RTTI_Element,
        url: RTTI_uri_1.RTTI_uri,
        _url: RTTI_Element_1.RTTI_Element,
        ifNoneMatch: t.string,
        _ifNoneMatch: RTTI_Element_1.RTTI_Element,
        ifModifiedSince: RTTI_instant_1.RTTI_instant,
        _ifModifiedSince: RTTI_Element_1.RTTI_Element,
        ifMatch: t.string,
        _ifMatch: RTTI_Element_1.RTTI_Element,
        ifNoneExist: t.string,
        _ifNoneExist: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_Bundle_Request.js.map